module.exports = __webpack_public_path__ + "img/jr45.b8e25933.jpg";